import React from 'react';

import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import Table from '../../../components/Table';
import Layout from '../../../containers/Layout';

import ServicerService from '../../../services/ServicerService';

const cols = [
  {
    title: 'Name',
    keys: ['name'],
    link: (row) => `/admin/servicers/${row.id}?tab=Servicer`,
  },
  {
    title: 'Access',
    keys: ['subdomain', 'domain'],
    format: (_, row) => {
      return `${row.subdomain}.${row.domain || 'pixelservicing.com'}`;
    },
    link: (row) =>
      `https://${row.subdomain}.${row.domain || 'pixelservicing.com'}`,
    isOuter: true,
  },
];

export default function HomePage() {
  const { data: servicers } = useQuery({
    queryKey: ['servicers'],
    queryFn: ServicerService.getServicers,
  });

  return (
    <Layout>
      <div className="flex">
        {/* Content area */}
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
          <main className="grow">
            <div className="px-4 sm:px-6 lg:px-8 py-8 pb-10 w-full max-w-9xl mx-auto">
              {/* Page header */}
              <div className="sm:flex sm:justify-between sm:items-center mb-8">
                {/* Left: Title */}
                <div className="mb-4 sm:mb-0">
                  <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
                    Admin
                  </h1>
                </div>

                {/* Right: Actions */}
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                  {/* Add servicer button */}
                  <Link
                    to="/admin/servicers/new?tab=Servicer"
                    className="btn bg-indigo-500 hover:bg-indigo-600 text-white"
                  >
                    <svg
                      className="w-4 h-4 fill-current opacity-50 shrink-0"
                      viewBox="0 0 16 16"
                    >
                      <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                    </svg>
                    <span className="hidden xs:block ml-2">New Servicer</span>
                  </Link>
                </div>
              </div>

              {/* Table */}
              <Table
                cols={cols}
                rows={servicers}
                title="Servicers"
                minHeight={565}
              />
            </div>
          </main>
        </div>
      </div>
    </Layout>
  );
}
